import Mexp from "math-expression-evaluator";
import { BaseQuantity } from "../interface/functionalityInterface";
import { CalculatorUnitProps } from "../interface/propTypesInterface";

export const equationHandler = (
  baseQuantity: BaseQuantity,
  calc: CalculatorUnitProps
) => {
  const bqs = calc.inputs[calc.selectedCalcMode].baseQuantities;
  const equation = calc.calculate[calc.selectedCalcMode].equations.find(
    (equation) => {
      return equation.target === baseQuantity.name;
    }
  );

  if (!equation) {
    alert(`No ${calc.name} equation to calculate ${baseQuantity.name}`);
    throw new Error(`no equation found for ${baseQuantity.name}`);
  }
  const variables = bqs.map((bq) => {
    let value: string;
    try {
      // Convert to base unit
      const preConvert = Mexp.eval(bq.value.replaceAll(",", "."));

      value = convertHandler(
        preConvert,
        bq.baseUnit,
        bq.selectedUnit,
        bq.units
      ).toString();
    } catch (error) {
      value = bq.value;
    }

    return {
      name: bq.name,
      // Convert to baseunit for calculation
      value: value,
    };
  });

  let parsedEquation = variables.reduce((acc, nV) => {
    const regex = new RegExp(`\\b${nV.name}\\b`, "g");
    return acc.replaceAll(regex, nV.value.toString());
  }, equation.expression);

  try {
    // Convert to correct unit
    const answer = Mexp.eval(parsedEquation);
    const convertedAnswer = convertHandler(
      answer,
      baseQuantity.selectedUnit,
      baseQuantity.baseUnit,
      baseQuantity.units
    );
    // Show correct amount of decimals
    return convertedAnswer;
  } catch (error) {
    console.log(`Could not evaluate ${parsedEquation}`);
    return 0;
  }
};

export const calculateHandler = (value: string) => {
  try {
    return Number(Mexp.eval(value));
  } catch (error) {
    return null;
  }
};

export const converterCalcHandler = (
  baseQuantity: BaseQuantity,
  noDecimals: number
) => {
  try {
    const evaluated = Mexp.eval(baseQuantity.value);
    return Number(evaluated).toFixed(noDecimals);
  } catch (error) {
    throw new Error("Error in converter calculator when changing decimals");
  }
};

export const convertHandler = (
  value: string,
  toUnit: string,
  fromUnit: string,
  units: {
    name: string;
    fromConst: number | string;
    toConst: number | string;
  }[]
): number => {
  const startUnit = units.find((unit) => unit.name === fromUnit);
  const endUnit = units.find((unit) => unit.name === toUnit);
  if (!startUnit || !endUnit)
    throw new Error(`No unit match for ${toUnit} or ${fromUnit}`);

  let fromStartToBase, fromBaseToEnd;
  try {
    if (startUnit.fromConst.toString().includes("value")) {
      fromStartToBase = Mexp.eval(
        startUnit.fromConst
          .toString()
          .replace("1e", "10^")
          .replace("value", value)
      );
    } else {
      fromStartToBase = Mexp.eval(
        `${value}*${startUnit.fromConst.toString().replace("1e", "10^")}`
      );
    }
    if (endUnit.toConst.toString().includes("value")) {
      fromBaseToEnd = Mexp.eval(
        endUnit.toConst
          .toString()
          .replace("1e", "10^")
          .replace("value", fromStartToBase)
      );
    } else {
      fromBaseToEnd = Mexp.eval(
        `${fromStartToBase}*${endUnit.toConst.toString().replace("1e", "10^")}`
      );
    }

    const finalValue: number = Number(fromBaseToEnd);
    return finalValue;
  } catch (error) {
    throw new Error(
      `Could not convert from ${startUnit.fromConst} to ${endUnit.toConst}`
    );
  }
};
